import { z } from 'zod';

export const merchantDetailsSchema = z.object({
  merchantName: z.string(),
  merchantAbn: z.string().optional(),
  merchantAddress: z.string()
});

export type MerchantDetails = z.infer<typeof merchantDetailsSchema>;
